// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__y_MzJ","title":"style_title__eCEWl","card":"style_card__QcxDz"};